<template>
  <div class="w12 confirm-page">
    <mypage-header> </mypage-header>
    <div>
      <div class="w12 mt20 mb20 evidence-box padding-content">
        <div class="content bold">오입금 및 환불</div>
        <div
          class="content default mt4"
          v-html="$t(`deposit.본인확인을 위한`)"
        ></div>
        <div class="w12 button-box mt8">
          <router-link to="/balances/deposit/proof" tag="button">{{
            $t("deposit.제출하기")
          }}</router-link>
        </div>
      </div>
    </div>
    <!-- #region 외국인 원화 입출금 제한 안내 -->
    <el-dialog
      title="안내"
      :visible.sync="foreignNotAllowedModal.show"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="modal-type01 popup"
      center
    >
      <div class="text-center">
        <p class="text-type01 mgb25">
          Only Korean Nationals can use the KRW market.
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="foreignNotAllowedModal.show = false">
          <span @click="$router.go(-1)" class="btn-style01">{{
            $t("confirm.ok")
          }}</span>
        </span>
      </span>
    </el-dialog>
    <!-- #endregion 외국인 원화 입출금 제한 안내 -->
  </div>
</template>

<script>
import Api from "@/common/Api";
import { mapGetters } from "vuex";

import MypageHeader from "./component/mypage/header.vue";

export default {
  components: {
    MypageHeader,
  },
  created() {
    // 외국인 여부 확인
    if (this.$store.getters.isForeign) {
      this.foreignNotAllowedModal.show = true;
      return false;
    }
  },
  data() {
    return {
      foreignNotAllowedModal: {
        show: false,
      },
    };
  },
  mounted() {
    this.$store.dispatch("updateUserInfo");
    Promise.all([
      Api.User.getUserPrivateInfo("email"),
      Api.User.getUserPrivateInfo("phone"),
    ]).then(([email, phone]) => {
      this.email = email.body.data;
      this.phone = phone.body.data;
    });

    this.foreign = this.isForeign;
  },
  computed: {
    ...mapGetters([
      "authLevel",
      "authStep",
      "userInfo",
      "accounts",
      "authResidence",
      "useOTP",
      "hasAccount",
    ]),
    isForeign() {
      return this.userInfo.foreignYn == "Y";
    },
    authData() {
      return {
        isPhone: this.phone ? true : false,
        isBank: this.hasAccount,
        isOtp: this.useOTP,
        isForeign: this.foreign,
        KYCType: this.authResidence,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  font-size: 12px;
}
.w12.button-box.mt8 {
  button {
    width: 100%;
    height: 42px;
    font-weight: bold;
  }
}
</style>
